import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logHikeEventCreatedParams = {
  custom_route_id?: number;
  entry_point?: CardLocation;
  event_id?: string;
  has_note?: boolean;
  trail_id?: number;
};

/**
 * User successfully creates a new Hike Event (server confirms creation). Tap of the 'Invite' / submit CTA after time and date are selected.
 * @param params - Attributes to log with the amplitude event
 * @param params.custom_route_id - Id of the custom route associated with the event.
 * @param params.entry_point - Surface where the create flow was originally initiated from (e.g., 'trail details').
 * @param params.event_id - Unique id of the newly created Hike Event.
 * @param params.has_note - Whether the organizer added a note to the event.
 * @param params.trail_id - Id of the trail associated with the event.
 */
const logHikeEventCreated = ({ custom_route_id, entry_point, event_id, has_note, trail_id }: logHikeEventCreatedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'hike event created',
    { 'custom route id': custom_route_id, 'entry point': entry_point, 'event id': event_id, 'has note': has_note, 'trail id': trail_id },
    callback
  );
};

export default logHikeEventCreated;
